import { IconType, SvgIcon } from './SvgIcon';

export const CogIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      fill="transparent"
      d="M10.0007 16.6666C11.7688 16.6666 13.4645 15.9642 14.7147 14.714C15.9649 13.4637 16.6673 11.768 16.6673 9.99992C16.6673 8.23181 15.9649 6.53612 14.7147 5.28587C13.4645 4.03563 11.7688 3.33325 10.0007 3.33325C8.23254 3.33325 6.53685 4.03563 5.28661 5.28587C4.03636 6.53612 3.33398 8.23181 3.33398 9.99992C3.33398 11.768 4.03636 13.4637 5.28661 14.714C6.53685 15.9642 8.23254 16.6666 10.0007 16.6666Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M10.0007 11.6666C10.4427 11.6666 10.8666 11.491 11.1792 11.1784C11.4917 10.8659 11.6673 10.4419 11.6673 9.99992C11.6673 9.55789 11.4917 9.13397 11.1792 8.82141C10.8666 8.50885 10.4427 8.33325 10.0007 8.33325C9.55862 8.33325 9.1347 8.50885 8.82214 8.82141C8.50958 9.13397 8.33398 9.55789 8.33398 9.99992C8.33398 10.4419 8.50958 10.8659 8.82214 11.1784C9.1347 11.491 9.55862 11.6666 10.0007 11.6666Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M10 1.66675V3.33341"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M10 18.3334V16.6667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M14.1673 17.2166L13.334 15.7749"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M9.16732 8.55845L5.83398 2.78345"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M17.2171 14.1666L15.7754 13.3333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M2.7832 5.83325L4.22487 6.66659"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M11.666 10H18.3327"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M1.66602 10H3.33268"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M17.2171 5.83325L15.7754 6.66659"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M2.7832 14.1666L4.22487 13.3333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M14.1673 2.78345L13.334 4.22511"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill="transparent"
      d="M9.16732 11.4417L5.83398 17.2167"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

CogIcon.displayName = 'CogIcon';
